import { createGlobalStyle } from 'styled-components';
import styledNormalize from 'styled-normalize';

import resetCss from './reset';
import globalCss from './global';

createGlobalStyle`
  ${styledNormalize}

  ${resetCss}
  ${globalCss}
`;

export { default as utils } from './utils';
export { default as variables } from './variables';
export { default as themeSwitcher } from './themeSwitcher';
